import React, { useEffect, useState } from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import { Accordion } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import moment from "moment-timezone";
import CurrencyConverter from "../../CurrencyConverter/CurrencyConverter";
import { api, subCategoryUploadDir } from "../../../config";
import messages from "../../../locale/messages";
import startIcon from '/public/Icons/startIcon.svg';
import pauseIcon from '/public/Icons/pauseIcon.svg';
import breakIcon from '/public/Icons/breakIcon.svg';
import playIcon from '/public/Icons/playIcon.svg';
import stopIcon from '/public/Icons/stopIcon.svg';
import accordionArrowIcon from '/public/dashboard/accordionArrowIcon.svg';
import bt from '../../commonStyle.css';
import s from './OrderAccordionItems.css';


const OrderAccordionItems = (props) => {
    const {
        id,
        isBooking,
        data,
        orderIndex,
        name,
        image,
        pricingType,
        currency,
        basePrice,
        workLogHistory,
        workDuration,
        totalQuantity,
        intl: { formatMessage },
        socket,
        refetch
    } = props

    const [collapseID, setCollapseID] = useState([])
    useEffect(() => {
        let variables = {};
        if (socket && id) {
            variables = { id };
            socket.on(`bookingStatus-${id}`, async () => {
                await isBooking && refetch && refetch(variables)
            });
        }
    }, [])

    const toggleCollapse = (id1) => {
        setCollapseID((prevCollapseID) => {
            if (prevCollapseID.includes(id1)) {
                return prevCollapseID.filter(id => id !== id1);
            } else {
                return [...prevCollapseID, id1];
            }
        });
    };

    let showWorkLogHistory = (data?.status === 'expired' || data?.status === 'cancelledByUser' || data?.status === 'cancelledByPartner') ? false : true;
    let isBookingStarted = workLogHistory?.length > 0 && workLogHistory.some(item => item.status === 'completed' || item.status === 'paused');

    return (
        <div className={s.orderCardItemContainer}>
            <Accordion>
                <Accordion.Toggle eventKey="0" onClick={() => toggleCollapse(orderIndex)} className={cx("orderAccordionHeader", { [bt.cursorDefault]: !(isBooking && isBookingStarted && showWorkLogHistory) })}>
                    <div className={s.orderCardItemWrapper}>
                        <div className={s.orderCardItemImgContainer}>
                            <img src={`${api.apiEndpoint}${subCategoryUploadDir}medium_${image}`} alt={name} width={50} height={50} />
                        </div>
                        <div className={s.orderCardItemInfoType}>
                            {pricingType === 'hourly' ?
                                <div className={cx(bt.commonSize14, bt.fontWeight700, bt.primaryColor, bt.textAlignStart)}>{name}</div> :
                                <div className={cx(bt.commonSize14, bt.fontWeight700, bt.primaryColor, bt.textAlignStart)}>{name} ({totalQuantity})</div>
                            }

                            <div className={cx(bt.commonSize16, bt.fontWeight600, bt.themeColor, bt.textAlignStart)}>
                                {
                                    pricingType == 'hourly' ? (
                                        <>
                                            <span className={bt.displayInlineBlock}>
                                                <CurrencyConverter amount={basePrice} from={currency} />&nbsp;
                                            </span>
                                            <span className={bt.displayInlineBlock}>{'/'}&nbsp;</span>
                                            <span className={bt.displayInlineBlock}><FormattedMessage {...messages.hourLabel} /></span>
                                        </>
                                    ) : (
                                        <>
                                            <span className={bt.displayInlineBlock}>
                                                <CurrencyConverter amount={basePrice} from={currency} />&nbsp;
                                            </span>
                                            <span className={bt.displayInlineBlock}>{'/'}&nbsp;</span>
                                            <span className={bt.displayInlineBlock}><FormattedMessage {...messages.quantityText} /></span>
                                        </>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                    {isBooking && isBookingStarted && showWorkLogHistory &&
                        <div className="svgImg">
                            <span className={'accordionArrow'}>
                                <img src={accordionArrowIcon} alt="" className={cx(collapseID.includes(orderIndex) ? 'accordionArrowDown' : 'accordionArrowUp')} />
                            </span>
                        </div>}
                </Accordion.Toggle>
                {isBooking && isBookingStarted && (
                    <Accordion.Collapse eventKey="0">
                        <div>
                            {
                                workLogHistory?.map((value, index2) => {
                                    return (
                                        <div className={s.orderAccordionBodyMediaItemContainer}>
                                            <div className={s.orderAccordionMediaItem}>
                                                <img src={index2 == 0 ? startIcon : playIcon} alt={index2 == 0 ? "startIcon" : "playIcon"} />
                                                <span className={cx(bt.commonSize14, bt.fontWeight400, bt.primaryColor)}>{moment(parseInt(value.startedAt)).format('hh:mm A')}</span>
                                            </div>
                                            {value.closedAt && <div className={s.orderAccordionMediaItem}>
                                                <img src={index2 == workLogHistory.length - 1 ? stopIcon : pauseIcon} alt={index2 == workLogHistory.length - 1 ? "stopIcon" : "pauseIcon"} />
                                                <span className={cx(bt.commonSize14, bt.fontWeight400, bt.primaryColor)}>{moment(parseInt(value.closedAt)).format('hh:mm A')}</span>
                                            </div>}
                                            {value.totalWork && <div className={s.orderAccordionMediaItem}>
                                                <img src={breakIcon} alt="breakIcon" />
                                                <span className={cx(bt.commonSize14, bt.fontWeight400, bt.primaryColor)}>{value.totalWork}</span>
                                            </div>}
                                        </div>
                                    )
                                })
                            }
                            {workDuration && <div className={s.orderAccordionBodyTotalBtnContainer}>
                                <div className={s.orderAccordionBodyTotalBtn}>
                                    <span className={bt.displayInlineBlock}>{formatMessage(messages.totalWorkingHours)}</span>
                                    <span className={bt.displayInlineBlock}>&nbsp;{workDuration}</span>
                                </div>
                            </div>}
                        </div>
                    </Accordion.Collapse>
                )}
            </Accordion>
        </div>
    )
}

export default injectIntl(withStyles(bt, s)(OrderAccordionItems));
